import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "custom-map-studio",
  ref: "boxRef"
}
const _hoisted_2 = { class: "map-controls-hint" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { id: "container" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("span", null, "滚轮缩放 · 拖拽移动画布 · 双击添加/删除标点", -1)),
      _createElementVNode("button", {
        class: "reset-view-btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetView && _ctx.resetView(...args))),
        title: "重置地图视野"
      }, " 复位 ")
    ])
  ], 512))
}